import React from 'react';
import { createRoot } from 'react-dom/client';
import OpeningBoard from './OpeningBoard';

// Separate webpack entry → its own bundle (js/dist/openingBoard.js), mounted only on the
// opening pages. Progressive enhancement: the server renders a static board inside #opening-board
// (crawlable, no JS); when this bundle loads it replaces that with the interactive board.
const el = document.getElementById('opening-board');
const raw = el?.dataset.moves?.trim();
if (el && raw) {
  const moves = raw.split(/\s+/).filter(Boolean);
  if (moves.length > 0) {
    el.innerHTML = '';
    createRoot(el).render(<OpeningBoard moves={moves} />);
  }
}
